import { render, staticRenderFns } from "./onlineCustomerList.vue?vue&type=template&id=546e5fc1&"
import script from "./onlineCustomerList.vue?vue&type=script&lang=js&"
export * from "./onlineCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546e5fc1')) {
      api.createRecord('546e5fc1', component.options)
    } else {
      api.reload('546e5fc1', component.options)
    }
    module.hot.accept("./onlineCustomerList.vue?vue&type=template&id=546e5fc1&", function () {
      api.rerender('546e5fc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/onlineCustomerList.vue"
export default component.exports